import gql from 'graphql-tag';

export const getShiftGroups = gql`
  query getShiftGroups {
    getShiftGroups {
      id
      name
    }
  }
`;
